import fetch from "../../utils/fetch";
/**
 * 账号申诉上传见证文件接口方法
 * author:陈冠赤
 */
export default {
    upload(file, refobj) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("companycode", refobj.companycode);
        formData.append("reftype", refobj.reftype);
        return fetch.post("/api/file/fileopt/uploadAllowNotLogin", formData, {headers: {'Content-Type': 'multipart/form-data'}});
    },
    deleteById(id){
        return fetch({
            url: "/api/file/fileopt/deletebyidAllowNotLogin",
            method: 'post',
            params: {id}
        })
    },
}
